import { Injectable } from '@angular/core';
import { Table, TableRawData } from '@schoolbelle/common/table';
import { MailMergeItem } from '@schoolbelle/api/letter';
import { keys, reduce, groupBy, values, sortBy, get } from 'lodash-es';
import { GroupMember, GroupMemberSearchService, GroupMemberType } from '@schoolbelle/api/group-member';
import { TreeGroup } from '@schoolbelle/api/group-to-group';

export type PossibleSearchTypes = 'class'|'type'|'name'|'phone-number';
export const possible_search_type_list:Array<PossibleSearchTypes> = ['class', 'type', 'name', 'phone-number'];



@Injectable()
export class MailmergeTableService extends GroupMemberSearchService {
  /**
   * 
   * @param list 
   * take mailmerge item list and turn it into tabledata
   */
  turnMailMergeListToTableArrayData (list:MailMergeItem[], header_search_keys:string[]):{body:Array<Array<any>>, header:Array<any>} {
    //values : take values and contain it to array...

    const header_data = list.find(li=>li.group_id === 0);
    if (header_data) {
      const header = [
        ...header_search_keys, 
        ...values(list.find(li=>li.group_id === 0).mm_data).filter(val=>!header_search_keys.includes(val)).map(val=>String(val))
      ];
      const body = list.filter(li=>li.group_id !== 0).map(li=>header.map(key=>li.mm_data[key] ? String(li.mm_data[key]) : undefined));
      return {body, header};
    }
    else return {body:[], header:[]};
  }
  /**
   * 
   * @param data 
   * take table data and turn it into list of mailmerge items
   */
  turnTableDataToMailMergeList (table:Table, translations:{Grade:string, Class:string, PhoneNumber:string, Num:string, Name:string}, memberMatchRequired:boolean):MailMergeItem[] {
    if (!table) return [];
    const headers = table.rows[0].cells.map(c=>c.val);   
    return [
      {
        group_id:0, // important
        scopes:'none', // important
        student_id:0,
        mm_data:reduce(headers, (acc, key, index)=>{ // important
          return {...acc, [''+index]:key}
        }, {}),
      }
    ].concat(
      table.rows.slice(1).map((row)=>{
        // empty row 
        if (!row.cells.find(c=>c.val)) return;

        const [cell1, cell2, cell3, cell4] = row.cells;
        const phone_number = cell4.val;
        const member_name = cell3.val;
        const member_type = cell2.val;
        const class_name = cell1.val;

        let member:GroupMember;
        let cls:TreeGroup;
        let grd:TreeGroup;

        if (memberMatchRequired) {
          member = (cell1.value && cell1.value.member) || (class_name ? this.findMember(member_name, member_type, class_name)[0] : this.findMemberDirectly(member_name, member_type))
          cls = member ? this.tree.root.find({group_id:member.group_id}) : null;
          grd = cls ? cls.parentgroup : null; 
          if (!member) return null;
        }
        const base = {
          [translations.Grade]: grd ? grd.group_name : null,
          [translations.Class]: class_name,
          [translations.Num]: member ? member.member_num : null,
          [translations.Name]: member_name,
          [translations.PhoneNumber]: phone_number,
          Grade : grd ? grd.group_name : null,
          Class : class_name,
          Num : member ? member.member_num : null,
          Name : member_name,
          PhoneNumber : phone_number,
        };
        return {
          group_id:member ? member.group_id : null,
          scopes:member ? this.member.turnMembertoScope(member, false): null,
          student_id:member && typeof member.member_id === 'string' ? Number(member.member_id.replace(/\D/g, '')) : null,
          mm_data: reduce(headers, (acc, key, x)=>{
            const cell = row.cells[x];
            //const cell = row.getCell(x);
            if (!key) return acc;
            if (base[key]) return acc;
            else return {...acc, [key]:cell.val};
          }, base) 
        }
      })
      .filter(r=>r)
    )

  }
}
